import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./ForgotPassword.scss";

// components
import Registration from "../../coraWebComponents/views/registration/Registration";
import { getURLParamsByNames } from "../../coraWebComponents/utils/helper";
import withRouter from "../../coraWebComponents/utils/withRouter";
import Alert from "../../coraWebComponents/Alert";
import { showMsg } from '../../coraWebComponents/utils/logger';  
                                                               
// routes
import Routes from "../../constants/Routes";

// actions
import * as loginActions from "../../actions/loginActions";

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      code: "",
    };
  }

  // FORM METHODS
  onSubmit = async (registrationState) => {
    const { code } = this.state;
    const { email, password } = registrationState;
    const { changePassword, forgotPassword, navigate } = this.props;

    if (code !== "") {
      await changePassword({ password, code });
      navigate(Routes.LOGIN, { replace: true });
    }
    else {
      await forgotPassword(email);
    }
  };
  onBackButtonHandle = () => {
    this.props.navigate(Routes.LOGIN, { replace: true });
  };
  onHideMsg = () => {
    this.props.signOut();
    this.props.navigate(Routes.LOGIN, { replace: true });
  };

  // SYSTEM METHODS
  componentDidMount() {
    const { code } = getURLParamsByNames(["code"]);
    if (code) this.setState({ code });
  }

  render() {
    const { isLoading, userMessage } = this.props;
    const { code } = this.state;

    return (
      <>
        <Registration
          isLoading={isLoading}
          header={<h1>Zmena hesla</h1>}
          onSubmit={this.onSubmit}
          showUsernameInput={false}
          registerButtonLabel={code ? "Zmeniť" : "Potvrdiť"}
          backButtonClick={this.onBackButtonHandle}
          hide={{ username: true, email: code !== "", password: code === "" }}
          showBackButton={code === ""}
        />
        {userMessage && <Alert msg={{ message: userMessage, messageType: 'ok' }} onHideMsg={this.onHideMsg} />}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.user.isLoading,
    userMessage: state.user.userMessage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changePassword: (data) => dispatch(loginActions.changePassword(data)),
  forgotPassword: (email) => dispatch(loginActions.forgotPassword(email)),
  signOut: () => dispatch(loginActions.signOut()),
});

ForgotPassword.propTypes = {
  changePassword: PropTypes.func,
  forgotPassword: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
);
